import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUnreadMessages } from './actions/fetch-unread-messages';
import { IUnreadMessagesPresence } from './types/unread-messages-interface';


const initialState: IUnreadMessagesPresence = {
    unreadMessagesPresence: false,
    isLoadingUnreadMessagesPresence: false,
    errorUnreadMessagesPresence: [],
};

export const UnreadMessagesPresence = createSlice({
    name: 'UnreadMessagesPresence',
    initialState,
    reducers: {
        resetUnreadMessagesPresence: (state) => {
            state.unreadMessagesPresence = false;
            state.isLoadingUnreadMessagesPresence = false;
            state.errorUnreadMessagesPresence = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUnreadMessages.pending, (state) => {
                state.isLoadingUnreadMessagesPresence = true;
            })
            .addCase(fetchUnreadMessages.fulfilled, (state, action: PayloadAction<{ unreadMessagesPresence: boolean }>) => {
                state.isLoadingUnreadMessagesPresence = false;
                state.unreadMessagesPresence = action.payload.unreadMessagesPresence;
                state.errorUnreadMessagesPresence = [];
            })
            .addCase(fetchUnreadMessages.rejected, (state, action) => {
                state.unreadMessagesPresence = false;
                state.isLoadingUnreadMessagesPresence = false;
                state.errorUnreadMessagesPresence = action.payload as string[];
            });
    },
});

export const { resetUnreadMessagesPresence } = UnreadMessagesPresence.actions;
export default UnreadMessagesPresence.reducer;